import { Component } from '@angular/core';

@Component({
  selector: 'app-university-logos-marquee',
  standalone: true,
  imports: [],
  templateUrl: './university-logos-marquee.component.html',
  styleUrl: './university-logos-marquee.component.scss'
})
export class UniversityLogosMarqueeComponent {

}
